/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FocoosTask } from '../../models/focoos-task';
import { ModelPreview } from '../../models/model-preview';
import { ModelStatus } from '../../models/model-status';

export interface ListModels$Params {
  statusFilter?: ModelStatus | null;
  taskFilter?: FocoosTask;
  includeMetrics?: boolean | null;
  datasetRef?: string;
}

export function listModels(http: HttpClient, rootUrl: string, params?: ListModels$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelPreview>>> {
  const rb = new RequestBuilder(rootUrl, listModels.PATH, 'get');
  if (params) {
    rb.query('statusFilter', params.statusFilter, {});
    rb.query('taskFilter', params.taskFilter, {});
    rb.query('includeMetrics', params.includeMetrics, {});
    rb.query('datasetRef', params.datasetRef, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ModelPreview>>;
    })
  );
}

listModels.PATH = '/v0/FocoosAI/models';
